import fromDtoToCategory from 'dto/timeOff/fromDtoToCategory.dto';
import asArray from 'utils/arrays/asArray.util';

const fromDtosToCategories = (array) => asArray(array).map(fromDtoToCategory);

export default fromDtosToCategories;
